module.exports = "/_next/static/images/na-347a6e2536bc3156650cacb2b3f3559b.svg";